import {
    EditInfoListLayout as Layout,
    InfoGroup as Info,
} from './EditInfoList';

const EditInfoList = {
    Layout,
    Info,
};
export default EditInfoList;
